<template>
  <div class="container page">
      <van-nav-bar :title="$t('setting.title')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="items">

        <div class="item van-hairline--bottom">
          <div class="left">{{ $t("VIP级别") }}</div>
          <div class="right">
            {{ userInfo.level_name }}
          </div>
        </div>

        <div class="item van-hairline--bottom" @click="toInfomation()">
          <div class="left">{{ $t("setting.basic") }}</div>
          <van-icon name="arrow" />
        </div>
        <div class="item van-hairline--bottom" @click="toLoginPassword()">
          <div class="left">{{ $t("登录密码") }}</div>
          <van-icon name="arrow" />
        </div>
        <div class="item van-hairline--bottom" @click="toPayPassword()">
          <div class="left">{{ $t("交易密码") }}</div>
          <div class="right">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="item van-hairline--bottom" @click="toLang()" v-if="false">
          <div class="left">{{ $t("setting.lang") }}</div>
          <div class="right">
            <span class="desc">{{ nameLangs() }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{ $t("注销") }}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{},
      lang:""
    };
  },
  methods: {
    nameLangs(){
      return this.$t("lang."+this.lang);
    },
    back(){
      return window.history.back();
    },
    names(paypassword){
      if(paypassword == "未设置"){
          return this.$t("msg.未设置")
      }else{
        return this.$t("msg.已设置")
      }
    },
    toPayPassword(){
      this.$router.push({path:'/SetPayPassword'});
    },
    toLang(){
      this.$router.push({path:'/SetLang'});
    },
    toLoginPassword(){
      this.$router.push({path:'/SetLoginPassword'});
    },
    toInfomation(){
      this.$router.push({path:'/Infomation'});
    },
    loginout(){
      localStorage.clear();
      localStorage.setItem('lang',this.lang);
      this.$router.push({path:'/Mine'});
    },
    toServicePage(){
      this.$router.push("ServicePage");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          if(res.data.paypassword){
            this.userInfo.paypassword = "已设置";
          }else {
            this.userInfo.paypassword = "未设置";
          }
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    }
  },
  created() {
    this.lang = localStorage.getItem('lang');
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style>
@import "../../assets/css/base.css";
.container .items{
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding: 0 25px;
}
.container .items .item{
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}
.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.container .sign-out{
  margin: 70px 5% ;
  height: 100px;
  line-height: 100px;
  border-radius: 20px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
}
.container  .item .desc{
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
.container .item .right{
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
